<confirm-popup
  mensagem="Essa ativação Poderá consumir Licença(s)!"
  iconeTipo="atencao"
  legendaConfirmar="Sim"
  legendaRejeitar="Não"
  [acaoConfirmar]="onConfirmarAtivar"
  #confirmPopupAtivar>
</confirm-popup>

<confirm-popup
  mensagem="Deseja realmente inativar a(s) empresa(s) selecionada(s)?"
  iconeTipo="atencao"
  legendaConfirmar="Sim"
  legendaRejeitar="Não"
  [acaoConfirmar]="onConfirmarInativar"
  [acaoRejeitar]="onRejeitarInativar"
  #confirmPopupInativar>
</confirm-popup>

<confirm-popup
  [mensagem]="textoConfirmacaoInativacao"
  iconeTipo="informacao"
  legendaConfirmar="Sim"
  legendaRejeitar="Não"
  legendaCancelar="Cancelar"
  cabecalho="Retomar Licenças?"
  [acaoConfirmar]="onConfirmarDevolverLicencas"
  [acaoRejeitar]="onRejeitarDevolverLicencas"
  #confirmPopupLicencas>
</confirm-popup>

<p-dialog
  styleClass="manutencao-lote-dialog"
  [(visible)]="modalResultadoAberto"
  [modal]="true"
  [style]="{ width: '1000px' }"
  [draggable]="false"
  [resizable]="true">

  <ng-template pTemplate="header">
    <span class="dialog-title">Resultado do Processamento</span>
  </ng-template>

  <section class="dialog-content">
    <div class="table-wrapper">
      <table class="-hoverable">
        <tr>
          <th>Empresa</th>
          <th>CNPJ</th>
          <th class="display-flex-center">Alterado</th>
        </tr>
        <tr *ngFor="let r of paginaResultado.conteudo">
          <td>{{ r.nome }}</td>
          <td>{{ maskCollection.formatarCpfCnpj(r.cnpjCpf) }}</td>
          <td class="display-flex-center">
            <div *ngIf="r.alterado && !r.justificativa" class="status-bolinha -verde" pTooltip="Alterado com sucesso"></div>
            <div *ngIf="r.alterado && r.justificativa" class="justificativa-container">
              <div class="status-bolinha -amarela" pTooltip="{{ r.justificativa }}"></div>
              <span class="justificativa-texto -amarela">{{ r.justificativa }}</span>
            </div>
            <div *ngIf="!r.alterado" class="justificativa-container">
              <div class="status-bolinha -vermelha" pTooltip="{{ r.justificativa }}"></div>
              <span class="justificativa-texto">{{ r.justificativa }}</span>
            </div>
          </td>
        </tr>
      </table>
      <div class="paginator-center" [style.display]="paginaResultado.totalConteudo > 1 ? 'flex' : 'none'">
        <mat-paginator [length]="paginaResultado.totalConteudo" [pageSize]="paginaResultado.quantidadeNaPagina"
                       [pageIndex]="paginaResultado.pagina" (page)="paginaAtualResultado=$event.pageIndex"></mat-paginator>
      </div>
    </div>
  </section>

  <ng-template pTemplate="footer">
    <div class="button-container -flexEnd">
      <button class="o-button -blue" type="button" (click)="fecharModalResultado()">Fechar</button>
    </div>
  </ng-template>
</p-dialog>
